import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { PCB_CORE_URL } from "../config";
import "./backoffice.css";
import { useStore } from "../store";
import { authHeader, clearAuthSession, getAccessToken } from "../authSession";

const API_BASE = (PCB_CORE_URL || "").replace(/\/+$/, "");

export default function BackofficeLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useStore((s) => s.user);
  const clearUser = useStore((s) => s.clearUser);

  const access = getAccessToken() || user?.access || "";

  const hasToken = !!access;
  const isAdmin = !!user?.is_staff || !!user?.is_superuser;

  const [mode, setMode] = useState("backoffice");

  useEffect(() => {
    let alive = true;
    const path = location.pathname || "";
    const m = path.match(/^\/bo\/quotes\/(\d+)(?:\/followup)?\/?$/i);

    if (!m || !access) {
      setMode("backoffice");
      return () => {
        alive = false;
      };
    }

    const quoteId = m[1];
    fetch(`${API_BASE}/superuser/quotes/${quoteId}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
    })
      .then(async (r) => {
        if (!r.ok) return null;
        return r.json();
      })
      .then((data) => {
        if (!alive) return;
        setMode(String(data?.status || "backoffice").toLowerCase());
      })
      .catch(() => {
        if (!alive) return;
        setMode("backoffice");
      });

    return () => {
      alive = false;
    };
  }, [location.pathname, access]);

  function handleLogout() {
    clearAuthSession();
    clearUser();
    navigate("/login");
  }

  if (!hasToken) {
    return (
      <div className="bo-wrap">
        <div className="bo-card">
          <div className="bo-title">Backoffice</div>
          <div className="bo-muted">Session expirée. Veuillez vous reconnecter.</div>
          <button className="bo-btn" onClick={() => navigate("/login")}>
            Aller au login
          </button>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="bo-wrap">
        <div className="bo-card">
          <div className="bo-title">Accès refusé</div>
          <div className="bo-muted">Vous n'avez pas les droits admin.</div>
          <button className="bo-btn" onClick={() => navigate("/projects")}>
            Retour
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bo-wrap">
      <aside className="bo-sidebar">
        <div className="bo-brand">
          <div className="bo-brand-title">BACKOFFICE</div>
          <div className="bo-brand-sub">Devis & Config</div>
        </div>

        <nav className="bo-nav">
          <NavLink to="/bo" end className={({ isActive }) => "bo-link" + (isActive ? " active" : "")}>Dashboard</NavLink>

          <div className="bo-section">Devis</div>
          <NavLink to="/bo/quotes" className={({ isActive }) => "bo-link" + (isActive ? " active" : "")}>Liste des devis</NavLink>

          <div className="bo-section">Clients</div>
          <NavLink to="/bo/clients" className={({ isActive }) => "bo-link" + (isActive ? " active" : "")}>Utilisateurs</NavLink>

          <div className="bo-section">Paramétrage</div>
          <NavLink to="/bo/config/suppliers" className={({ isActive }) => "bo-link" + (isActive ? " active" : "")}>Configuration commerciale</NavLink>
        </nav>

        <div className="bo-footer">
          <button className="bo-btn bo-btn-danger" onClick={handleLogout}>Déconnexion</button>
        </div>
      </aside>

      <main className="bo-main">
        <div className="bo-topbar">
          <div className="bo-topbar-title">Administration</div>
          <div className="bo-topbar-right">
            <span className="bo-pill">Mode: {mode}</span>
          </div>
        </div>

        <div className="bo-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
